'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var Analytics = require('../global/analytics');
var FormsAPI = require('./forms-api');
var AjaxForm = require('./ajax-form');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e['default'] : e; }

var Analytics__default = /*#__PURE__*/_interopDefaultLegacy(Analytics);
var FormsAPI__default = /*#__PURE__*/_interopDefaultLegacy(FormsAPI);
var AjaxForm__default = /*#__PURE__*/_interopDefaultLegacy(AjaxForm);

class AjaxEmailForm extends AjaxForm__default {
  constructor(form, options) {
    const validations = [{
      name: form.querySelector('input[type="email"]').getAttribute('name'),
      fn: FormsAPI__default.validateEmail
    }];
    super(form, validations, options);
  }

  trackSuccess() {
    const successEvent = this.form.dataset.gaFormSuccessEvent;

    if (successEvent) {
      Analytics__default.track(successEvent, 'Email form', 'Success');
    }
  }

}

exports.default = AjaxEmailForm;
